import React from 'react'
import PT from 'prop-types'
import Dialog from '@vimcar/shared-components/components/Dialog'
import linkStore from '@vimcar/shared-utils/linkStore'
import Button from '@vimcar/shared-components/components/Button'
import SwaggerForm from '@vimcar/shared-components/components/SwaggerForm'
import TextField from '@vimcar/shared-components/components/TextField'

import Err from '#components/Err'
import i18n from '#utils/i18n'
import mkStore from './store'
import definitions from './definitions'
import styles from './styles.css'

const tp = i18n.prefix('components.EditEmailDialog')

const EditEmailDialog = ({ loading, store }) => (
  <Dialog
    onClose={store.handleClickClose}
    title={tp('title')}
    >
    <TextField
      disabled
      classNameInner={styles.input}
      floatingLabelText={tp('email')}
      value={store.currentEmail}
      />
    {store.showForm && (
      <SwaggerForm
        className={styles.form}
        data={store.data}
        definition={definitions.email}
        fields={store.fields}
        i18n={i18n}
        onChange={store.handleChange}
        onSubmit={store.handleSubmit}
        >
        {store.error && <Err>{store.error}</Err>}
        <Button
          raised
          className={styles.button}
          disabled={loading}
          type='submit'
          >
          {tp('update-email')}
        </Button>
      </SwaggerForm>
    )}
    {store.showDone && (
      <React.Fragment>
        <p>{tp('close-text')}</p>
        <Button
          raised
          className={styles.button}
          onClick={store.handleClickClose}
          >
          {tp('close')}
        </Button>
      </React.Fragment>
    )}
  </Dialog>
)

EditEmailDialog.propTypes = {
  loading: PT.bool.isRequired,
  store: PT.object.isRequired,
}

export default linkStore(mkStore, EditEmailDialog)
